export const handleSetPhoneNumber = (
    event: React.ChangeEvent<Element>,
    callback: (field: 'phone', value: string | undefined) => void
) => {
    const { value } = event.target as HTMLInputElement;
    const cleaned = value.replace(/\D/g, '');
    const matchFirst = cleaned.match(/^(\d{1,3})$/);
    const matchSecond = cleaned.match(/^(\d{3})(\d{1,3})$/);
    const matchFinal = cleaned.match(/^(\d{3})(\d{3})(\d{1,4})$/);

    let finalValue = '';

    if (matchFinal) {
        finalValue = `(${matchFinal[1]}) ${matchFinal[2]}-${matchFinal[3]}`;
    } else if (matchSecond) {
        finalValue = `(${matchSecond[1]}) ${matchSecond[2]}`;
    } else if (matchFirst) {
        finalValue = `(${matchFirst[1]}`;
    }

    callback('phone', finalValue);
};
